import PropTypes from 'prop-types'

import { Icon } from '../display/icon'

const LocationIcon = ({ label = 'Location', ...rest }) => {
  return (
    <Icon
      label={label}
      {...rest}
      dangerouslySetGlyph={`<svg data-name="Layer 1" viewBox="0 0 300 300"><path d="M233 108.5c0 11.8-1.8 21.4-5.3 29L168.6 263a19 19 0 0 1-7.7 8.4 20.7 20.7 0 0 1-21.8 0 18.2 18.2 0 0 1-7.6-8.4L72.3 137.5c-3.5-7.6-5.3-17.2-5.3-29q0-34.4 24.3-58.7T150 25.5q34.4 0 58.7 24.3t24.3 58.7zm-53.7 29.3a39.5 39.5 0 0 0 12.2-29.3A41.5 41.5 0 0 0 150 67a41.5 41.5 0 0 0-41.5 41.5A41.7 41.7 0 0 0 150 150a39.9 39.9 0 0 0 29.3-12.2z" style="fill:#b1ce5f"/><path d="M150 25.5q34.4 0 58.7 24.3t24.3 58.7c0 11.8-1.8 21.4-5.3 29L168.6 263a19 19 0 0 1-7.7 8.4 20.7 20.7 0 0 1-21.8 0 18.2 18.2 0 0 1-7.6-8.4L72.3 137.5c-3.5-7.6-5.3-17.2-5.3-29q0-34.4 24.3-58.7T150 25.5m0 124.5a41.7 41.7 0 0 0 41.5-41.5A41.5 41.5 0 0 0 150 67a41.5 41.5 0 0 0-41.5 41.5A41.7 41.7 0 0 0 150 150m0-134.5c-25.6 0-47.7 9.1-65.8 27.2S57 82.9 57 108.5c0 13.2 2.1 24.4 6.3 33.3l59.1 125.4a29.1 29.1 0 0 0 11.5 12.8 31.1 31.1 0 0 0 32.2 0 29.1 29.1 0 0 0 11.5-12.6h.1l59-125.5c4.2-8.9 6.3-20.1 6.3-33.3 0-25.6-9.2-47.7-27.2-65.8S175.6 15.5 150 15.5zm0 124.5a31.4 31.4 0 0 1-31.5-31.5A31.4 31.4 0 0 1 150 77a31.4 31.4 0 0 1 31.5 31.5A31.4 31.4 0 0 1 150 140z" style="fill:#1d1d1b"/></svg>`}
    />
  )
}

LocationIcon.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large'])
}

export { LocationIcon }
